import { browser } from '$app/environment';
import type PostHogJs from 'posthog-js';

// posthog-js is browser-only and fires a fetch on import — must be lazy to
// avoid SSR side effects.  See docs/posthog-ssr-eager-fetch-bug.md.
//
// The import is deferred until the browser is idle (requestIdleCallback) so
// neither the SDK (~96ms) nor the session recorder (~1.3s) touches the
// critical rendering path.  All consumers use optional chaining
// (getPostHog()?.method()) and gracefully no-op before the SDK is ready.
let _posthog: typeof PostHogJs | undefined;

let _resolve: () => void;
const _ready = new Promise<void>((r) => {
  _resolve = r;
});

if (browser) {
  const load = () =>
    import('posthog-js').then((m) => {
      _posthog = m.default;
      _resolve();
    });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => load());
  } else {
    setTimeout(() => load(), 1);
  }
}

/** Returns the posthog-js instance (browser-only, undefined during SSR). */
export function getPostHog() {
  return _posthog;
}

/** Resolves when the posthog-js module has been loaded (browser-only). */
export function whenReady(): Promise<void> {
  return _ready;
}
